import React, { useEffect, useState } from 'react'

import history from '../../history'
import VideoList from './VideoList'
import VideoAi from './VideoAi'

const VideoAiHandler = props => {
  const [isEdit, setIsEdit] = useState(false)
  const [videoId, setVideoId] = useState(null)
  const [initialStep, setInitialStep] = useState(null)

  const {
    match: {
      params: { id, step }
    }
  } = props

  useEffect(() => {
    if (id) {
      setIsEdit(true)
      setVideoId(id)
      setInitialStep(step || null)
    } else {
      setIsEdit(false)
      setVideoId(null)
      setInitialStep(null)
    }
  }, [id, step])

  const handleEditNavigation = video => {
    const videoId = video.id
    history.push(`/video-create/${videoId}/uploadDocument`)
  }

  const handleCreateNew = () => {
    setIsEdit(true)
    setVideoId(null)
    setInitialStep(null)
  }

  if (isEdit) {
    return (
      <VideoAi
        videoId={videoId}
        initialStep={initialStep}
        handleGoBack={() => {
          if (id) {
            history.push('/video-create')
          } else {
            setIsEdit(false)
          }
        }}
      />
    )
  }

  return (
    <VideoList
      onCreateNew={handleCreateNew}
      onEditVideo={handleEditNavigation}
    />
  )
}

export default VideoAiHandler
